import React from 'react';

import AccordionItem from './AccordionItem';

function Accordion(props) {
  const {
    theme = 'default',
    customClassItemWrapper = '',
    wrapperClassNames = ''
  } = props;
  const [bindIndex, setBindIndex] = React.useState(props.defaultIndex);

  const changeItem = (itemIndex, data) => {
    if (itemIndex !== bindIndex) {
      setBindIndex(itemIndex);
    } else {
      setBindIndex(null);
    }

    if (props.onCallBack && data) {
      props.onCallBack(data);
    }
  };
  const items = props.children;

  return (
    <div className={`wrapper ${wrapperClassNames}`}>
      {items.map(({ props }) => (
        <AccordionItem
          isCollapsed={bindIndex !== props.index}
          label={props.label}
          handleClick={() => changeItem(props.index, props.tabData)}
          children={props.children}
          icon={props.icon}
          theme={theme}
          linkOnClick={props.linkOnClick}
          linkText={props.linkText}
          customClassItemWrapper={customClassItemWrapper}
        />
      ))}
    </div>
  );
}

export default Accordion;
